[
  {
    "code": "ID-SM-AC",
    "name": "Aceh"
  },
  {
    "code": "ID-NU-BA",
    "name": "Bali"
  },
  {
    "code": "ID-SM-BB",
    "name": "Bangka Belitung"
  },
  {
    "code": "ID-JW-BT",
    "name": "Banten"
  },
  {
    "code": "ID-SM-BE",
    "name": "Bengkulu"
  },
  {
    "code": "ID-SL-GO",
    "name": "Gorontalo"
  },
  {
    "code": "ID-JW-JK",
    "name": "Jakarta Raya"
  },
  {
    "code": "ID-SM-JA",
    "name": "Jambi"
  },
  {
    "code": "ID-JW-JB",
    "name": "Jawa Barat"
  },
  {
    "code": "ID-JW-JT",
    "name": "Jawa Tengah"
  },
  {
    "code": "ID-JW-JI",
    "name": "Jawa Timur"
  },
  {
    "code": "ID-KA-KB",
    "name": "Kalimantan Barat"
  },
  {
    "code": "ID-KA-KS",
    "name": "Kalimantan Selatan"
  },
  {
    "code": "ID-KA-KT",
    "name": "Kalimantan Tengah"
  },
  {
    "code": "ID-KA-KI",
    "name": "Kalimantan Timur"
  },
  {
    "code": "ID-SM-KR",
    "name": "Kepulauan Riau"
  },
  {
    "code": "ID-SM-LA",
    "name": "Lampung"
  },
  {
    "code": "ID-MA-MA",
    "name": "Maluku"
  },
  {
    "code": "ID-MA-MU",
    "name": "Maluku Utara"
  },
  {
    "code": "ID-NU-NB",
    "name": "Nusa Tenggara Barat"
  },
  {
    "code": "ID-NU-NT",
    "name": "Nusa Tenggara Timur"
  },
  {
    "code": "ID-IJ-PA",
    "name": "Papua"
  },
  {
    "code": "ID-IJ-PB",
    "name": "Papua Barat"
  },
  {
    "code": "ID-SM-RI",
    "name": "Riau"
  },
  {
    "code": "ID-SL-SR",
    "name": "Sulawesi Barat"
  },
  {
    "code": "ID-SL-SN",
    "name": "Sulawesi Selatan"
  },
  {
    "code": "ID-SL-ST",
    "name": "Sulawesi Tengah"
  },
  {
    "code": "ID-SL-SG",
    "name": "Sulawesi Tenggara"
  },
  {
    "code": "ID-SL-SA",
    "name": "Sulawesi Utara"
  },
  {
    "code": "ID-SM-SB",
    "name": "Sumatera Barat"
  },
  {
    "code": "ID-SM-SS",
    "name": "Sumatera Selatan"
  },
  {
    "code": "ID-SM-SU",
    "name": "Sumatera Utara"
  },
  {
    "code": "ID-JW-YO",
    "name": "Yogyakarta"
  }
]